<ng-container rtBlock="sc-blog-button-block">
    @if (href(); as link) {
        @if (button().label) {
            <a
                rtButton
                rtElem="link"
                qa-dataid="blog-button-block"
                [href]="link"
                [attr.target]="button().newTab ? '_blank' : null"
                [attr.rel]="rel()">
                {{ button().label }}
            </a>
        }
    }
</ng-container>
